export default __webpack_public_path__ + "static/media/frame_1.55c8a52a.png";